export default "__VITE_ASSET__40cf4fcc__"